<template>
    <div class="container">
        <div class="title">{{device.device_name}}
            <span style="color:rgba(245, 170, 0, 1);margin-left:16rem">
                <!-- 运行电压下降，补偿效果较差 -->
            </span>
        </div>
        <div class="body">
            <div class="left">
                <div class="left-item" style="color:rgba(104, 216, 106, 1)">
                    <div>投</div>
                    <div>
                        {{switching_tou}}
                    </div>
                </div>
                <div class="left-item" style="color:rgba(253, 66, 56, 1)">
                    <div>切</div>
                    <div>
                        {{switching_qie}}
                    </div>
                </div>
            </div>
            <div class="center">
                <div class="title">功率因数</div>
                <div class="center-value" :style="color()">
                    {{pf}}<span>&nbsp;&nbsp;{{icon()}}</span>
                </div>
                <div class="center-desc">功率因数过低可以造成设备利用率降低，线路损耗增加，供电局功率因数罚款（利率电费）。</div>
            </div>
            <div class="right">
                <div class="right-item">
                    <div class="title">总电流谐波</div>
                    <div class="right-item-font">
                        <span style="color:rgb(104, 216, 106)">{{$store.getters.mqttVal(device.subLoopUrl + '/THD_I') == undefined ? '--' : floatFormat($store.getters.mqttVal(device.subLoopUrl + '/THD_I'),2)}}%</span>
                    </div>
                    <!-- <div class="right-item-font">
                        A相：&nbsp;&nbsp;<span>{{$store.getters.mqttVal(device.subLoopUrl + '/THD_Ia') == undefined ? '--' : floatFormat($store.getters.mqttVal(device.subLoopUrl + '/THD_Ia'),2)}}%</span>
                    </div>
                    <div class="right-item-font">
                        B相：&nbsp;&nbsp;<span>{{$store.getters.mqttVal(device.subLoopUrl + '/THD_Ib') == undefined ? '--' : floatFormat($store.getters.mqttVal(device.subLoopUrl + '/THD_Ib'),2)}}%</span>
                    </div>
                    <div class="right-item-font">
                        C相：&nbsp;&nbsp;<span>{{$store.getters.mqttVal(device.subLoopUrl + '/THD_Ic') == undefined ? '--' : floatFormat($store.getters.mqttVal(device.subLoopUrl + '/THD_Ic'),2)}}%</span>
                    </div> -->
                </div>
                <div class="right-item">
                    <div class="title">总电压谐波</div>
                    <div class="right-item-font">
                        <span style="color:rgb(104, 216, 106)">{{$store.getters.mqttVal(device.subLoopUrl + '/THD_U') == undefined ? '--' : floatFormat($store.getters.mqttVal(device.subLoopUrl + '/THD_U'),2)}}%</span>
                    </div>
                    <!-- <div class="right-item-font">
                        A相：&nbsp;&nbsp;<span>{{$store.getters.mqttVal(device.subLoopUrl + '/THD_Ua') == undefined ? '--' : floatFormat($store.getters.mqttVal(device.subLoopUrl + '/THD_Ua'),2)}}%</span>
                    </div>
                    <div class="right-item-font">
                        B相：&nbsp;&nbsp;<span>{{$store.getters.mqttVal(device.subLoopUrl + '/THD_Ub') == undefined ? '--' : floatFormat($store.getters.mqttVal(device.subLoopUrl + '/THD_Ub'),2)}}%</span>
                    </div>
                    <div class="right-item-font">
                        C相：&nbsp;&nbsp;<span>{{$store.getters.mqttVal(device.subLoopUrl + '/THD_Uc') == undefined ? '--' : floatFormat($store.getters.mqttVal(device.subLoopUrl + '/THD_Uc'),2)}}%</span>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        floatFormat
    } from "../../util/MathUtil"

    export default {
        name: "CapacitanceItems",
        props: ['device'],
        data() {
            return {
                switching: ['Status_a', 'Status_b', 'Status_c', 'Status_d', 'Status_e']
            }
        },
        created() {},
        mounted() {
            if( this.$store.state.project.currentProject.projectId == 5){
                this.switching = ['Status_a', 'Status_b', 'Status_c', 'Status_d', 'Status_e', 'Status_f', 'Status_g', 'Status_h', 'Status_i', 'Status_j']
            }else{
                this.switching = ['Status_a', 'Status_b', 'Status_c', 'Status_d', 'Status_e']
            }
        },
        computed: {
            pf() {
                if (this.$store.getters.projectId == 4) {
                    // 有功
                    let Pa = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/Pa'))
                    let Pb = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/Pb'))
                    let Pc = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/Pc'))
                    let P = Pa + Pb + Pc
                    // 视在
                    let PAa = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/PAa'))
                    let PAb = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/PAb'))
                    let PAc = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/PAc'))
                    let PA = PAa + PAb + PAc
                    if (isNaN(P) || isNaN(PA) || PA == 0) {
                        return '--'
                    } else {
                        return parseFloat(Number((P / PA).toFixed(2)))
                    }
                } else {
                    return this.$store.getters.mqttVal(this.device.subLoopUrl + '/PF') == undefined ? '--' :
                        Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/PF')).toFixed(2)
                }

                // return this.$store.getters.mqttVal(this.device.subLoopUrl + '/PF') == undefined ? '--' :
                //     this.$store.getters.mqttVal(this.device.subLoopUrl + '/PF')
            },
            switching_tou() {
                let num = 0,
                    status = 0
                this.switching.forEach((item) => {
                    if (this.$store.getters.mqttVal(this.device.subLoopUrl + '/' + item) == undefined) {
                        status += 1
                    } else if (this.$store.getters.mqttVal(this.device.subLoopUrl + '/' + item) == 1) {
                        num += 1
                    }
                })
                return status == 5 ? '--' : num
            },
            switching_qie() {
                let num = 0,
                    status = 0
                this.switching.forEach((item) => {
                    if (this.$store.getters.mqttVal(this.device.subLoopUrl + '/' + item) == undefined) {
                        status += 1
                    } else if (this.$store.getters.mqttVal(this.device.subLoopUrl + '/' + item) == 0) {
                        num += 1
                    }
                })
                return status == 5 ? '--' : num
            }
        },
        methods: {
            floatFormat,
            color() {
                if (!this.pf) {
                    return "color:#FD4238";
                } else if (this.pf > 0.9) {
                    return "color:#68D86A";
                } else if (this.pf > 0.5) {
                    return "color:#F5AA00";
                } else {
                    return "color:#FD4238";
                }
            },
            icon() {
                if (!this.pf) {
                    return "";
                } else if (this.pf > 0.9) {
                    return "优";
                } else if (this.pf > 0.5) {
                    return "良";
                } else if (this.pf <= 0.5) {
                    return "差";
                } else {
                    return ''
                }
            }
        }
    };
</script>

<style lang="less" scoped>
    .container {
        width: 100%;
        .h(285);
        background: #fff;
        margin-top: 80/108vh;
        padding: 240/108vh 240/192vw;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
            font-size: 18rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
        }

        .body {
            .h(204);
            .w(1552);
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .left {
                .w(280);
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .left-item {
                    width: 100%;
                    .h(98);
                    background: rgba(0, 43, 102, 0.04);
                    font-size: 30rem;
                    font-weight: bold;
                    font-family: Source Han Sans CN;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    div {
                        width: 50%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }

            .center {
                .w(584);
                height: 100%;
                background: rgba(0, 43, 102, 0.04);
                padding: 32rem 48rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;

                .center-value {
                    font-size: 36rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                }

                .center-desc {
                    font-size: 14rem;
                    color: #999;
                }
            }

            .right {
                .w(664);
                height: 100%;
                background: rgba(0, 43, 102, 0.04);
                display: flex;
                flex-direction: row;

                .right-item {
                    width: 50%;
                    height: 100%;
                    padding: 35rem 0 25rem 63rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;

                    span {
                        color: rgba(13, 148, 255, 1);
                    }

                    .right-item-font {
                        font-size: 36rem;
                        font-weight: bold;
                        padding-top: 20rem;
                    }
                }
            }
        }
    }
</style>